import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import Login from "./pages/loginPages";
import ParentComponent from "./componants/bodyComponent";
import Header from "./componants/header";
import Footer from "./componants/footer";
import CreateUser from "./pages/createPages";
import UpdatePassword from "./pages/changePasswordPages";
import ResetPasswordMail from "./pages/resetPasswordMailPages";
import ResetPassword from "./pages/changePasswordFromMailPages";
import darkTheme from "./theme/darkTheme";
import lightTheme from "./theme/lightTheme";
import { ThemeProvider } from '@mui/material/styles';
import "./App.css"

function App() {
  const [token, setToken] = useState(sessionStorage.getItem("token"));
  const [username, setUsername] = useState(sessionStorage.getItem("username"));
  const [viewRole, setViewRole] = useState(sessionStorage.getItem("viewRole"));
  const [isAdmin, setIsAdmin] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem("darkMode");
    if (savedMode === null) return false;
    return savedMode === "true";
  });

  // Toggle du thème
  const toggleDarkMode = () => {
    setDarkMode(prevMode => {
      const newMode = !prevMode;
      localStorage.setItem("darkMode", newMode.toString());
      return newMode;
    });
  };

  const currentTheme = darkMode ? darkTheme : lightTheme;

  // Fonction pour vérifier si l'utilisateur est admin
  const checkAdmin = async (token) => {
    if (!token) {
      setIsAdmin(false);
      return;
    }
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMAIN_URL + "/api/isAdmin",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
            "Pragma": "no-cache"
          },
        }
      );
      setIsAdmin(response.data.isAdmin);
      console.log("isAdmin:", response.data.isAdmin);
    } catch (error) {
      console.error("Erreur lors de la vérification", error);
      setIsAdmin(false);
    }
  };

  // Vérifier isAdmin au chargement de la page
  useEffect(() => {
    if (token) {
      checkAdmin(token);
    }
  }, [token]);

  // Appliquer le fond sombre sans utiliser CssBaseline
  useEffect(() => {
    if (darkMode) {
      document.body.style.backgroundColor = '#121212';
    } else {
      document.body.style.backgroundColor = '';
    }
  }, [darkMode]);

  const handleLogin = (token, username, viewRole) => {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("viewRole", viewRole); // viewRole pour l'UI
    sessionStorage.setItem("username", username);

    setToken(token);
    setViewRole(viewRole);
    setUsername(username);
  }

  // Fonction à appeler après un switch de rôle (exportée via Header)
  const handleAfterRoleSwitch = (newToken, newViewRole) => {
    sessionStorage.setItem("token", newToken);
    sessionStorage.setItem("viewRole", newViewRole);

    setToken(newToken);
    setViewRole(newViewRole);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("viewRole");
    sessionStorage.removeItem("username");
    setToken(null);
    setViewRole(null);
    setUsername(null);
    setIsAdmin(false);
  };


  return (
<ThemeProvider theme={currentTheme}>
  <div id="root">
    <Router>
      {token && <Header role={viewRole} isAdmin={isAdmin} onLogout={handleLogout} onRoleSwitch={handleAfterRoleSwitch} toggleDarkMode={toggleDarkMode} />}
        <main className="mainContent">
        <Routes>
          <Route path="/login" element={
            !token ? <Login setToken={handleLogin} /> : <Navigate to="/dashboard" />
          }/>
          <Route
            path="/createUser"
            element={
              token && isAdmin ? <CreateUser roleUser={viewRole} /> : <Navigate to="/login"  />
            }
          />
          <Route
            path="/changePassword"
            element={
              token ? <UpdatePassword role={viewRole}/> : <Navigate to="/login" />
            }
          />
          <Route path="/passwordResetMail" element={<ResetPasswordMail />} />
          <Route path="/resetPassword/:token" element={<ResetPassword />} />
          <Route
            path="/dashboard"
            element={
              token ? <ParentComponent role={viewRole} isAdmin={isAdmin} /> : <Navigate to="/login" />
            }
          />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
        </main>
      {token && <Footer role={viewRole} />}
    </Router>
  </div>
</ThemeProvider>
  );
}

export default App;
